import request from "@/utils/request";

// oss签名
export async function getOssConfigApi(params) {
  return request("/mtsV2/oss/signature/get", {
    params,
  });
}

export const getOssConfigV2Api = (data) =>
  request("/mtsV2/oss/signatureV2/getByEnumKey", {
    method: "POST",
    data,
  });

// 提交下载任务
export async function submitExportTask(params) {
  const formData = new FormData();
  formData.append("params", params);
  return request("/export.do", {
    method: "POST",
    data: formData,
    params,
  });
}
// 查询下载进度
export async function pollingExportStatus(downloadId) {
  return request("/exportProcess.do", {
    params: { downloadId },
  });
}
